export const customTableStyles = {
  headCells: {
    style: {
      backgroundColor: "#B7D3FB",
      fontWeight: "bold"
    }
  }
}